/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowARightIcon16Light } from './ArrowARightIcon16Light';
import { ArrowARightIcon16Regular } from './ArrowARightIcon16Regular';
import { ArrowARightIcon16Solid } from './ArrowARightIcon16Solid';
import { ArrowARightIcon20Light } from './ArrowARightIcon20Light';
import { ArrowARightIcon20Regular } from './ArrowARightIcon20Regular';
import { ArrowARightIcon20Solid } from './ArrowARightIcon20Solid';
import { ArrowARightIcon24Regular } from './ArrowARightIcon24Regular';
import { ArrowARightIcon24Solid } from './ArrowARightIcon24Solid';
import { ArrowARightIcon32Regular } from './ArrowARightIcon32Regular';
import { ArrowARightIcon64Regular } from './ArrowARightIcon64Regular';
var sizes = {
    16: {
        light: ArrowARightIcon16Light,
        regular: ArrowARightIcon16Regular,
        solid: ArrowARightIcon16Solid,
    },
    20: {
        light: ArrowARightIcon20Light,
        regular: ArrowARightIcon20Regular,
        solid: ArrowARightIcon20Solid,
    },
    24: {
        regular: ArrowARightIcon24Regular,
        solid: ArrowARightIcon24Solid,
    },
    32: {
        regular: ArrowARightIcon32Regular,
    },
    64: {
        regular: ArrowARightIcon64Regular,
    },
};
export var ArrowARightIcon = forwardRef('ArrowARightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
